<div class="printable">
  <div class="card-wrapper">
    <!-- RECTO -->
    <div class="card" #recto>
      <!-- Logo ajouté en haut à gauche -->
      <div class="logo-container">
        <img src="assets/oprag-logo.png" alt="Logo" class="logo">
      </div>

      <!-- Banderolle aux couleurs du Gabon - Version corrigée -->
      <div class="gabon-flag">
        <div class="flag-strip green"></div>
        <div class="flag-strip yellow"></div>
        <div class="flag-strip blue"></div>
      </div>

      <div class="subtitle"><h2 class="text-blue-900"><strong>CARTE
            D'INSPECTION</strong></h2></div>
      <div class="title"><strong>OPRAG / CIMFEP</strong></div>

      <div class="content">
        <div class="info-container">
          <div class="info">
            <div><label>Rapport n° :</label> <strong>{{badge.numero}}</strong>
            </div>
            <div><label>Validité :</label>
              <strong>{{ creationDate ? (creationDate | date: 'dd/MM/yyyy') : ''
                }} - {{ expirationDate | date: 'dd/MM/yyyy' }}</strong></div>
            <div><label>N° immat :</label>
              <strong>{{badge.numeroParc}}</strong></div>
            <div><label>Entreprise :</label>
              <strong>{{badge.certificatControl.societe}}</strong></div>
            <div><label>Code Inspecteur :</label> <strong>{{
                badge.inspecteur.userName?badge.inspecteur.userName:""}}</strong></div>
          </div>

          <!-- Nouvelle image à droite des informations -->
          <div class="info-image">
            <img src="assets/Logo CIMFEP.png" alt="Information additionnelle">
          </div>
        </div>

        <!-- Nouvelle structure pour étendre le bleu sur toute la largeur -->
        <div class="full-width-partners">
          <div class="partners">
            PARTENAIRE TECHNIQUE<br>
            <strong>{{ badge.inspecteur.inspection.nom }}</strong><br>
          </div>
        </div>
      </div>

      <div class="qr">
        <img [src]="imageUrl" alt="QR Code">
      </div>
    </div>

    <!-- VERSO -->
    <div class="card" #verso>
      <!-- Logos des partenaires en haut -->
      <div class="partners-logos">
        <div class="partner-logo left">
          <img src="assets/Logo HP.jpg" alt="Partenaire gauche">
          <h2 class="mt-0 text-xl font-semibold logo_text_color">CFHP</h2>
        </div>
        <div class="partner-logo-bajinn right">
          <img src="assets/Logo BAJINN.png" alt="Partenaire droit">
        </div>
      </div>

      <div class="verso">
        <h4>CARTE ÉDITÉE PAR</h4>
        <b>© GDT - GABON DIGITAL TRANSPORTS<br>
          GRPE PROLAB AFRIK</b>
        <p>
          Usage exclusif aux zones portuaires autorisées.<br>
          Ne pas plier. Ne pas exposer à une source magnétique.
        </p>
        <small>https://prolabafrik.com</small>

        <!-- Logo en bas -->
        <div class="bottom-logo">
          <img src="assets/Logo Prolab Afrik entier.svg" alt="Logo bas">
        </div>
      </div>
    </div>
  </div>
</div>

<input class="print-button" type="file" (change)="onFileSelected($event)"
  accept="image/*" /> <br>
<button class="print-button" (click)="printCard()">Imprimer la carte</button>
